<template>
    <div class="flex mb-2">
        <Toolbar class="w-full">
        <template #end>
            <DatePicker v-model="datePiker" dateFormat="dd/mm/yy" showIcon @value-change="onDateChange" />
        </template>
        </Toolbar>
    </div>

    <div>
        <div class="flex gap-2 my-2">
            <Card class="flex-1">
                <template #title>
                <h4 class="m-0">Concluídos Mensal</h4>
                </template>
                <template #content>
                <Chart v-if="_isMounted && concluidosMes?.labels?.length && concluidosMes?.datasets?.length" :key="`concluidosMes-${datePiker?.getTime?.() || 0}`" type="bar" :data="concluidosMes" :options="estiloColunaVertical" />
                </template>
            </Card>

            <Card class="flex-1">
                <template #title>
                <h4 class="m-0">Concluídos Diário</h4>
                </template>
                <template #content>
                <Chart v-if="_isMounted && concluidosDia?.labels?.length && concluidosDia?.datasets?.length" :key="`concluidosDia-${datePiker?.getTime?.() || 0}`" type="bar" :data="concluidosDia" :options="estiloColunaVertical" />
                </template>
            </Card>

            <div class="flex flex-column gap-2 flex-1 pt-2.5">
                <Card class="flex-1" style="overflow: hidden; text-align: center">
                    <template #content>
                        <div class="flex flex-column justify-content-center align-items-center h-full" style="height: 120px;">
                            <b>{{ infosGerais.totalPendencias }}</b>
                            <p class="m-0 text-red-500"><b>Pendências</b></p>
                        </div>
                    </template>
                </Card>

                <Card class="flex-1" style="overflow: hidden; text-align: center">
                    <template #content>
                        <b>{{ infosGerais.totalCancelados }}</b>
                        <p class="m-0 text-red-500"><b>Cancelados</b></p>
                    </template>
                </Card>
            </div>
        </div>

        <div class="flex gap-2 my-2">
            <Card class="flex-1">
                <template #title>
                <h4 class="m-0">Contratos Atuais</h4>
                </template>
                <template #content>
                <Chart v-if="_isMounted && qtdEtapas?.labels?.length && qtdEtapas?.datasets?.length" :key="`qtdEtapas-${datePiker?.getTime?.() || 0}`" type="bar" :data="qtdEtapas" :options="estiloColunaHorizontal" />
                </template>
            </Card>

            <Card class="flex-1">
                <template #title>
                <h4 class="m-0">Agendamentos Diários</h4>
                </template>
                <template #content>
                <Chart v-if="_isMounted && agendamentosDia?.labels?.length && agendamentosDia?.datasets?.length" :key="`agendamentosDia-${datePiker?.getTime?.() || 0}`" type="bar" :data="agendamentosDia" :options="estiloColunaVertical" />
                </template>
            </Card>

            <Card class="flex-1">
                <template #title>
                <h4 class="m-0">Backlog</h4>
                <small class="text-gray-500">Contratos em etapa de lead e cotação</small>
                </template>
                <template #content>
                <Chart v-if="_isMounted && backlog?.labels?.length && backlog?.datasets?.length" :key="`backlog-${datePiker?.getTime?.() || 0}`" type="bar" :data="backlog" :options="estiloColunaVertical" />
                </template>
            </Card>
        </div>
    </div>
</template>

<script>
import Message from 'primevue/message';
import Button from "primevue/button";
import SafeChart from '@/components/SafeChart.vue';
import Card from 'primevue/card';
import BlockUI from 'primevue/blockui';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Toolbar from 'primevue/toolbar';
import DatePicker from 'primevue/datepicker';

import Cliente from '@/service/cliente.js';
import Usuario from '@/service/usuario.js';
import Contrato from '@/service/contrato.js';
import Pendencia from '@/service/pendencia.js';

export default {
    components: {
        Message,
        Button,
        Chart: SafeChart,
        Card,
        BlockUI,
        DataTable,
        Column,
        Toolbar,
        DatePicker,
    },
    data() {
        return {
            datePiker: new Date,
            infosGerais: {
                totalCancelados: 0,
                totalPendencias: 0,
            },

            estiloColunaHorizontal: {
                indexAxis: 'y',
                responsive: true,
                plugins: {
                    legend: {
                        display: false, // <-- Remove a legenda
                    }
                },
            },
            estiloColunaVertical: {
                responsive: true,
                plugins: {
                    // legend: {
                    //     display: true,
                    //     position: 'top'
                    // }
                    legend: {
                        display: false, // <-- Remove a legenda
                    }
                }
            },

            concluidosMes: {},
            concluidosDia: {},
            agendamentosDia: {},
            qtdEtapas: {},

            etapasDias: {},
            etapasMes: {},
            usuariosContratosMesMaiores: {},
            usuariosContratosMesMenores: {},
            contratosMes: {},
            atuacaoEstado: {},
            contratoMaioresClientes: {},

            backlog: {},

            contratosVisible: false,
            contratosStatus: null,

            _isMounted: false,
        }
    },
    mounted() {
        this._isMounted = true;
        this.onDateChange();
        this.loadEtapasTotal();
        this.loadBacklog();
    },
    beforeUnmount() {
        this._isMounted = false;
    },
    methods: {
        onBarClick(event) {
            const index = event.element.index;
            this.contratosStatus = this.qtdEtapas.labels[index];
            this.dialogVisible = true;
        },
        onDateChange() {
            this.loadConcluidoMensal();
            this.loadConcluidoDiario();
            this.loadAgendamentoDiario();
            this.loadTotais();
        },

        loadConcluidoMensal() {
            let date = this.datePiker;
            Contrato.concluidosMensal([`data=${date.toISOString().split('T')[0]}`].join("&"))
                .then(response => {
                    if (!this._isMounted) return;
                    const data = response.data.data;
                    const labels = response.data.labels;
                    const datasets = [
                        { label: 'Concluídos', data: [], tension: 0.4 },
                    ];

                    data.forEach((item, idx) => {
                        datasets[0].data.push(item.concluido);
                    });

                    this.concluidosMes = {
                        labels: labels,
                        datasets: datasets,
                    }
                });
        },

        loadConcluidoDiario() {
            let date = this.datePiker;
            Contrato.concluidosDiario([`data=${date.toISOString().split('T')[0]}`].join("&"))
                .then(response => {
                    if (!this._isMounted) return;
                    const data = response.data.data;
                    const labels = response.data.labels;
                    const datasets = [
                        { label: 'Concluídos', data: [], tension: 0.4 },
                    ];

                    data.forEach((item, idx) => {
                        datasets[0].data.push(item.concluido);
                    });

                    this.concluidosDia = {
                        labels: labels,
                        datasets: datasets,
                    }
                });
        },

        loadAgendamentoDiario() {
            let date = this.datePiker;
            Contrato.agendamentosDiario([`data=${date.toISOString().split('T')[0]}`].join("&"))
                .then(response => {
                    if (!this._isMounted) return;
                    const data = response.data.data;
                    const labels = response.data.labels;
                    const datasets = [
                        { label: 'Agendamentos', data: [], tension: 0.4 },
                    ];

                    data.forEach((item, idx) => {
                        datasets[0].data.push(item.agendado);
                    });

                    this.agendamentosDia = {
                        labels: labels,
                        datasets: datasets,
                    }
                });
        },

        loadBacklog() {
            let date = this.datePiker;
            Contrato.backlog([`data=${date.toISOString().split('T')[0]}`].join("&"))
                .then(response => {
                    if (!this._isMounted) return;
                    const data = response.data.data;

                    // Monta labels e valores
                    const labels = ["5 dias", "15 dias", "30 dias", "45+ dias"];
                    const valores = [
                        data.dias_5,
                        data.dias_15,
                        data.dias_30,
                        data.dias_45_plus
                    ];

                    const datasets = [
                        {
                            label: 'Backlog',
                            data: valores,
                            backgroundColor: ['#29B6F6', '#FFA726', '#66BB6A', '#EF5350'],
                            tension: 0.4
                        }
                    ];

                    this.backlog = {
                        labels: labels,
                        datasets: datasets,
                    };
                });
        },

        loadEtapasTotal() {
            let date = this.datePiker;
            Contrato.etapasQuantidade()
                .then(response => {
                    if (!this._isMounted) return;
                    const data = response.data.data;

                    const lead          = data.find(item => item.id === 1);
                    const cotacao       = data.find(item => item.id === 2);
                    const provedor      = data.find(item => item.id === 3);
                    const assinatura    = data.find(item => item.id === 4);

                    const labels = ["Leads", "Provedor e Assinatura", "Cotação"];
                    const datasets = [
                        {
                            label: 'Contratos',
                            data: [
                                lead ? lead.total : 0,
                                (provedor ? provedor.total : 0) + (assinatura ? assinatura.total : 0),
                                cotacao ? cotacao.total : 0
                            ],
                            backgroundColor: ['#29B6F6', '#FFA726', '#66BB6A'],
                        }
                    ];

                    this.qtdEtapas = {
                        labels: labels,
                        datasets: datasets,
                    };
                });
        },
        loadTotais() {
            let date = this.datePiker;
            Contrato.totalCancelado()
                .then(response => {
                    if (this._isMounted) this.infosGerais.totalCancelados = response.data.total;
                });
            Pendencia.qtdTotal([`data=${date.toISOString().split('T')[0]}`, `filter[pen.categoria_id][]=3`, `filter[pen.categoria_id][]=4`, `filter[pen.resolvido]=0`].join("&"))
                .then(response => {
                    if (this._isMounted) this.infosGerais.totalPendencias = response.data.total;
                });
        },

    }
}
</script>
